<script setup>

import {computed} from "vue";
import { store } from '@/store'

const props = defineProps({
  title: String,
  type: String,
  cardState: Object
})

const standard = computed(() => {
  return {
    single: store.formData.standardsAnnualSummary.single[props.type],
    couple: store.formData.standardsAnnualSummary.couple[props.type]
  }
})
const cardClass = computed(() => {
  return `standard-preset-card ${props.type}`
})
const open = computed(() => {
  return (props.cardState.expanded === props.type)
})
const selectCard = () => {
  props.cardState.expanded = open ? '' : props.type
}
</script>

<template>
  <div :class="cardClass" v-on:click="selectCard">
    <div class="spc__head">
      <h3 class="spc__title">{{ props.title }}</h3>
      <p class="spc__figure">£{{ standard.single !== undefined ? standard.single.toLocaleString() : '' }}</p>
      <p class="spc__note">Based on an average single person</p>
      <!-- <p class="spc__figure">Couple: £{{ standard.couple !== undefined ? standard.couple.toLocaleString() : '' }}</p> -->
    </div>
    <div class="spc__body">
      <span class="spc__graphic"></span>
      <p class="spc__text">
        <slot/>
        <span class="spc__cross" :data-open="open">
          <span class="spc__cross-mask"></span>
          <span class="spc__cross-mask"></span>
          <span class="spc__cross-mask"></span>
          <span class="spc__cross-mask"></span>
        </span>
      </p>
    </div>
  </div>
</template>
